// Type guards ----------------------------------------------------------------
export const isRiskSignalDriverLicenseRelevantCategory = (category) => {
    const relevantCategoryKeys = [
        'compromised_document',
        'data_comparison',
        'data_consistency',
        'data_validation',
        'image_integrity',
        'visual_authenticity',
    ];
    return relevantCategoryKeys.includes(category.key);
};
export const isRiskSignalDriverLicensePropertyKey = (property) => {
    const propertyKeys = [
        'abnormal_document_features',
        'blurred_photo',
        'corner_removed',
        'covered_photo',
        'custom_supported_document',
        'cut_off_document',
        'damaged_document',
        'dark_photo',
        'digital_document',
        'document_on_printed_paper',
        'glare_on_photo',
        'incorrect_side',
        'issuing_country_subject_to_sanctions',
        'missing_back',
        'no_document_in_image',
        'obscured_data_points',
        'obscured_security_features',
        'onfido_supported_document',
        'other_photo_issue',
        'photo_of_screen',
        'punctured_document',
        'sanctioned_issuing_country',
        'scan',
        'screenshot',
        'two_documents_uploaded',
        'watermarks_digital_text_overlay',
    ];
    return propertyKeys.includes(property);
};
